import { useEffect, useState } from 'react';
import { apiFetch } from '@/client/lib/api';

/**
 * Fetches available skill branch names from GCS.
 * Pass null to skip fetching.
 */
export function useSkillBranches(endpoint: string | null = '/api/skill-branches') {
  const [branches, setBranches] = useState<string[]>([]);
  const [loading, setLoading] = useState(!!endpoint);

  useEffect(() => {
    if (!endpoint) return;
    setLoading(true);
    apiFetch<{ branches: string[] }>(endpoint)
      .then((res) => setBranches(res.branches))
      .catch(() => setBranches([]))
      .finally(() => setLoading(false));
  }, [endpoint]);

  return { branches, loading };
}
